/**
 * @file: mediaSourceUtil.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { MediaSourceType } from '@euler/model/report';

export const MediaSourceTypeTextMap: { [p in MediaSourceType]: string } = {
  [MediaSourceType.Dashboard]: '仪表盘',
  [MediaSourceType.Facade]: '外观检查',
  [MediaSourceType.Inspection]: '全车检测',
  [MediaSourceType.Diagnostic]: '诊断检测', // obsoleted
  [MediaSourceType.Construction]: '施工反馈',
  [MediaSourceType.DeliveryCheck]: '交车检查',
  [MediaSourceType.Order]: '接车信息',
  [MediaSourceType.CustomIssue]: '自定义故障',
};
